import { useState } from "react";

export const useCarFilters = () => {
  // Filter states
  const [selectedBrands, setSelectedBrands] = useState(new Set());
  const [selectedEngineCapacities, setSelectedEngineCapacities] = useState(
    new Set()
  );
  const [selectedFuelTypes, setSelectedFuelTypes] = useState(new Set());
  const [selectedShapes, setSelectedShapes] = useState(new Set());
  const [selectedTransmissions, setSelectedTransmissions] = useState(new Set());
  const [selectedModels, setSelectedModels] = useState(new Set());

  // Price filters
  const [maxPrice, setMaxPrice] = useState();
  const [minPrice, setMinPrice] = useState();

  // Year
  const [maxYear, setMaxYear] = useState();
  const [minYear, setMinYear] = useState();

  // Static filter data
  const shapes = [
    "sedan",
    "hatchback",
    "suv",
    "convertible",
    "pickup truck",
    "other",
  ];

  const transmissions = [
    "Automatic",
    "Manual",
    "4x4",
    "Hyprid",
    "Electric",
    "other",
  ];

  const fuelTypes = ["Petrol", "Gasoline", "Diesel", "Natural Gas", "Electric"];
  const engineCapacities = [1000, 1600, 2000, 2400];

  const toggleBrandCheckbox = (brand) => {
    console.log("brand: ", brand);
    if (selectedBrands.has(brand)) {
      const prev = new Set(selectedBrands);
      prev.delete(brand);
      setSelectedBrands(prev);

      const updatedModels = new Set(
        [...selectedModels].filter((model) => model.brand !== brand.id)
      );
      setSelectedModels(updatedModels);
    } else {
      setSelectedBrands((prev) => new Set(prev).add(brand));
    }
  };

  const toggleTransmissionCheckbox = (transmission) => {
    if (selectedTransmissions.has(transmission)) {
      const prev = new Set(selectedTransmissions);
      prev.delete(transmission);
      setSelectedTransmissions(prev);
    } else {
      setSelectedTransmissions((prev) => new Set(prev).add(transmission));
    }
  };

  const toggleShapesCheckbox = (shape) => {
    if (selectedShapes.has(shape)) {
      const prev = new Set(selectedShapes);
      prev.delete(shape);
      setSelectedShapes(prev);
    } else {
      setSelectedShapes((prev) => new Set(prev).add(shape));
    }
  };

  const toggleFuelTypesCheckbox = (type) => {
    if (selectedFuelTypes.has(type)) {
      const prev = new Set(selectedFuelTypes);
      prev.delete(type);
      setSelectedFuelTypes(prev);
    } else {
      setSelectedFuelTypes((prev) => new Set(prev).add(type));
    }
  };

  const toggleEngineCapacitiesCheckbox = (capacity) => {
    if (selectedEngineCapacities.has(capacity)) {
      const prev = new Set(selectedEngineCapacities);
      prev.delete(capacity);
      setSelectedEngineCapacities(prev);
    } else {
      setSelectedEngineCapacities((prev) => new Set(prev).add(capacity));
    }
  };

  const toggleModelCheckbox = (model) => {
    const existingModel = [...selectedModels].find((m) => m.id === model.id);

    if (existingModel) {
      const prev = new Set(selectedModels);
      prev.delete(existingModel);
      setSelectedModels(prev);
    } else {
      setSelectedModels((prev) => new Set(prev).add(model));
    }
  };

  const clearFilters = () => {
    setMaxPrice();
    setMinPrice();
    setMaxYear();
    setMinYear();
    setSelectedBrands(new Set());
    setSelectedEngineCapacities(new Set());
    setSelectedFuelTypes(new Set());
    setSelectedShapes(new Set());
    setSelectedTransmissions(new Set());
    setSelectedModels(new Set());
  };

  const isCleared = () => {
    return (
      selectedBrands.size === 0 &&
      selectedTransmissions.size === 0 &&
      selectedEngineCapacities.size === 0 &&
      selectedFuelTypes.size === 0 &&
      selectedShapes.size === 0 &&
      selectedModels.size === 0 &&
      (minYear === "" || minYear === undefined) &&
      (maxYear === "" || maxYear === undefined) &&
      (minPrice === "" || minPrice === undefined) &&
      (maxPrice === "" || maxPrice === undefined)
    );
  };

  return {
    selectedBrands,
    setSelectedBrands,
    selectedEngineCapacities,
    setSelectedEngineCapacities,
    selectedFuelTypes,
    setSelectedFuelTypes,
    selectedShapes,
    setSelectedShapes,
    selectedTransmissions,
    setSelectedTransmissions,
    selectedModels,
    setSelectedModels,
    maxPrice,
    setMaxPrice,
    minPrice,
    setMinPrice,
    maxYear,
    setMaxYear,
    minYear,
    setMinYear,

    shapes,
    transmissions,
    fuelTypes,
    engineCapacities,

    toggleBrandCheckbox,
    toggleTransmissionCheckbox,
    toggleShapesCheckbox,
    toggleFuelTypesCheckbox,
    toggleEngineCapacitiesCheckbox,
    toggleModelCheckbox,
    clearFilters,
    isCleared,
  };
};
